import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  clientInfluencerDataRequestDetails,
  clientInfluencerSuggested,
  manualInfluencerSuggested,
} from "../../features/influencerRequestSlice/influencerRequestSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FormattedInput from "../common/FormattedInput";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import useDecodedToken from "../../features/utils/hooks/useDecodedToken";
import Breadcrumbs from "./../../Breadcrumbs";
import CreateVideoDM from "../common/CreateVideoDM";
import CreateVideo from "../common/CreateVideo";
import {
  fetchClientData,
  fetchClientFilteredData,
} from "../../features/influencerSlice/influencerSlice";
import Filter from "../filter/Filter";
import SubRequestFilter from "../filter/SubRequestFilter";
import { getLanguages } from "../../utils/dateUtils";

//features/utils/hooks/useDecodedToken';

export const headerData = {
  channel: "Channels",
  followers_subs: "Required Followers / Subscriber",
  languges: "Language",
  video_type: "Video Type",
};

export const headerDataInfluencer = {
  reg_id: "Req Id",
  influencer_name: "Influencer Name",
  channel_name: "Channel Name",
  video_type: "Video Type",
  inf_coste: "Influencer Cost",
  editable_inf_coste: "Editable Influencer Cost",
  video_cat: "Video Category",
  channel_link: "Channel Link",
  subscribe: "Subscribers",
  ave_view: "Average Views",
  languges: "Language",
  action: "Action",
};

export const headerManulDataInfluencer = {
  influencer_name: "Influencer Name",
  channel_name: "Channel Name",
  video_type: "Video Type",
  inf_coste: "Influencer Cost",
  editable_inf_coste: "Editable Influencer Cost",
  video_cat: "Video Category",
  channel_link: "Channel Link",
  subscribe: "Subscribers",
  ave_view: "Average Views",
  languges: "Language",
  action: "Action",
};

const DEFAULT_INF_TYPE = {
  label: "Own Influencer",
  value: "1",
};

const ClientInfluencerRequestDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const decodedToken = useDecodedToken();
  const [formData, setFormData] = useState({
    channel_name: [],
    categories: [],
    languages: [],
    budget: { min: "", max: "" },
    subscribers: { min: "", max: "" },
    views: { min: "", max: "" },
    salesteam: null,
    inf_type: DEFAULT_INF_TYPE,
    userName: null,
    follower_subscriber: null,
    filter_channel: null,
    language_filter: null,
    infnr_status: { value: "99", label: "All" },
  });

  const [checkedItems, setCheckedItems] = useState({});
  const [inputValues, setInputValues] = useState({});

  const [lastValidValues, setLastValidValues] = useState({});
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [inputError, setInputError] = useState(false);
  const [inputErrors, setInputErrors] = useState({}); // Track input errors per row
  const [updatedRequestData, setUpdatedRequestData] = useState([]); // State for updated values

  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [clientsPerPage, setClientsPerPage] = useState(10);

  const [appliedFilters, setAppliedFilters] = useState(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [isInitialLoadDone, setIsInitialLoadDone] = useState(false);

  const [filterType, setFilterType] = useState("all");
  const [filterCount, setFilterCount] = useState("");

  const selectedData = location.state;
  const { influencerRequestDatadetails, influencerSuggested, status, message } =
    useSelector((state) => state.requestInfluencerDetails);

  const { clientData, status: statusData } = useSelector(
    (state) => state.infDataList,
  );

  //   const { clientData, status: statusData } = useSelector(
  //   (state) => state.infDataList
  // );

  const [requestData, setRequestData] = useState([]);
  const [channelData, setChannelData] = useState({});
  const [toastDisplayed, setToastDisplayed] = useState(false);

  const [videoDmData, setVideoDmData] = useState("");
  const [addDmVideo, setAddDmVideo] = useState(false);
  const [activeTab, setActiveTab] = useState("auto");

  const handleAddVideo = (dataRows) => {
    setVideoDmData(dataRows);
    setAddDmVideo(true);
  };

  // Fetch request details when component loads
  useEffect(() => {
    console.log("activeTab ==>", activeTab);

    if (selectedData?.id) {
      let payload = {};
      if (activeTab === "manual") {
        payload = {
          inf_req_id: selectedData?.id,
          page: currentPage,
          limit: clientsPerPage === 2000 ? "All" : String(clientsPerPage),
          inf_type: null,
          user_id: null,
          follower_subscriber: null,
          filter_channel: null,
          language_filter: null,
        };
      } else if (activeTab === "suggested") {
        payload = {
          inf_req_id: selectedData?.id,
          page: currentPage,
          limit: clientsPerPage === 2000 ? "All" : String(clientsPerPage),
          inf_type: null,
          user_id: null,
          follower_subscriber: null,
          filter_channel: null,
          language_filter: null,
        };
      } else {
        payload = {
          inf_req_id: selectedData?.id,
        };
      }
      dispatch(clientInfluencerDataRequestDetails({ payload, activeTab }));
    }
  }, [dispatch, selectedData, activeTab, currentPage, clientsPerPage]);

  // useEffect(() => {
  //   if (activeTab !== "manual") return;
  //   if (!selectedData?.id) return;

  //   const payload = {
  //     inf_req_id: selectedData?.id,
  //     page: currentPage,
  //     limit: clientsPerPage === 2000 ? "All" : clientsPerPage,
  //   };

  //   dispatch(fetchClientData(payload));
  // }, [activeTab, currentPage, clientsPerPage, selectedData?.id]);

  // Update request data once the details are fetched
  useEffect(() => {
    if (status === "succeeded") {
      setRequestData(influencerRequestDatadetails?.data || []);
      setUpdatedRequestData(influencerRequestDatadetails?.data || []); // Initialize updated data
    }
  }, [status, influencerRequestDatadetails, toastDisplayed]);

  // const [manualTableData, setManualTableData] = useState([]);
  // useEffect(() => {
  //   if (activeTab === "manual" && statusData === "succeeded") {
  //     setManualTableData(clientData?.data || []);
  //   }
  // }, [clientData, statusData, activeTab]);

  // Filter and set channel data
  useEffect(() => {
    if (influencerRequestDatadetails?.request_details) {
      const filteredChannelData = Object.entries(
        influencerRequestDatadetails.request_details?.channel_details,
      )
        .filter(([key, value]) => key.endsWith("_status") && value === "1")
        .map(([key]) => key.replace("_status", ""))
        .reduce((acc, channel) => {
          acc[channel] =
            influencerRequestDatadetails.request_details?.channel_details[
              channel
            ];
          return acc;
        }, {});
      setChannelData(filteredChannelData);
    }
  }, [influencerRequestDatadetails]);

  // Handle selecting all checkboxes

  const handleHeaderCheckboxChange = (checked) => {
    const newCheckedItems = {};

    if (activeTab === "auto") {
      updatedRequestData.forEach((data, index) => {
        if (data?.SuggestionStatus === 0) {
          newCheckedItems[index] = checked;
        }
      });
    }

    if (activeTab === "manual") {
      manualInfluencers.forEach((data, index) => {
        newCheckedItems[index] = checked;
      });
    }

    if (activeTab === "suggested") {
      suggestedInfluencers.forEach((data, index) => {
        if (Number(data?.infStatus) !== 1) {
          newCheckedItems[index] = checked;
        }
      });
    }

    setCheckedItems(newCheckedItems);
    setIsAllChecked(checked);
  };

  // Handle individual checkbox changes
  const handleCheckboxChange = (event) => {
    const { checked, name } = event.target;

    setCheckedItems((prevState) => {
      const updated = {
        ...prevState,
        [name]: checked,
      };

      let currentData = [];

      if (activeTab === "auto") {
        currentData = updatedRequestData.filter(
          (item) => item?.SuggestionStatus === 0,
        );
      } else if (activeTab === "manual") {
        currentData = manualInfluencers;
      } else if (activeTab === "suggested") {
        currentData = suggestedInfluencers.filter(
          (item) => Number(item?.infStatus) !== 1,
        );
      }

      const allChecked =
        currentData.length > 0 &&
        currentData.every((_, index) => updated[index]);

      setIsAllChecked(allChecked);

      return updated;
    });
  };

  // Handle input value changes (influencer cost)
  // const handleInputChange = (event) => {
  //   const { name, value } = event.target;

  //   setInputValues((prev) => {
  //     // If value is empty, use the last valid value or fallback to data.sales_cost
  //     if (value === "") {
  //       return {
  //         ...prev,
  //         [name]: lastValidValues[name],
  //       };
  //     }

  //     // Update last valid values
  //     setLastValidValues((prevState) => ({
  //       ...prevState,
  //       [name]: value,
  //     }));

  //     return {
  //       ...prev,
  //       [name]: value,
  //     };
  //   });
  // };

  const handleInputChange = (event) => {
  const { name, value } = event.target;

  setInputValues((prev) => ({
    ...prev,
    [name]: value,
  }));
};

  const openFilterDrawer = (type) => {
    setFilterType(type);
    setShowFiltersDrawer(true);
  };
  // Handle form submission
  const handleSubmitBtn = () => {
    // let uniqueIndex = 0;
    const anyChecked = Object.values(checkedItems).some((checked) => checked);

    if (!anyChecked) {
      toast.error("Please select at least one influencer.");
      return; // Stop further execution if no checkbox is checked
    }
    const selectedRows = requestData
      .map((data, index) => {
        if (checkedItems[`${data?.id}`]) {
          const cost = inputValues[`cost_${data.id}`];
          setInputErrors((prev) => ({ ...prev, [data?.id]: false }));
          if (!cost) {
            setInputErrors((prev) => ({ ...prev, [data?.id]: true }));
            toast.error(
              `Please enter cost for ${data?.influencer_info?.name || "the influencer"}.`,
            );
            return null; // Skip this row
          }

          const influencerCost = data?.influencer_channel_video_cost; // Assuming this holds the influencer's cost
          if (parseFloat(cost) <= parseFloat(influencerCost)) {
            setInputErrors((prev) => ({ ...prev, [data?.id]: true }));
            toast.error(
              `The cost for ${data?.influencer_info?.name} must be less than the influencer's cost (${influencerCost}).`,
            );
            return null; // Skip this row
          }
          return {
            chechedValue: checkedItems[`${data?.id}`] || false,
            uniqueValue: data?.uniqueValue,
            dm_cost: cost, // Editable cost
          };
        }
        return null; // Not checked
      })
      .filter(Boolean);
    if (selectedRows.length > 0 && activeTab === "auto") {
      console.log("sfsjkdhjksdhf ==>", activeTab);

      const requestDataToSend = { selectedRows };
      dispatch(clientInfluencerSuggested(requestDataToSend))
        .unwrap()
        .then((result) => {
          if (result.status) {
            setToastDisplayed(true);
            toast.success(result.message, {
              onClose: () => {
                setToastDisplayed(false);
                // Update the requestData and updatedRequestData on toast close
                setUpdatedRequestData((prevData) =>
                  prevData.map((item, index) =>
                    checkedItems[index]
                      ? { ...item, dm_cost: inputValues[`cost${index}`] }
                      : item,
                  ),
                );
                setRequestData(influencerRequestDatadetails?.data || []);
                setCheckedItems([]);
                setIsAllChecked([]);
              },
            });
          }
        });
    } else if (activeTab === "manual") {

  const selectedRows = manualInfluencers
    .filter((row) => checkedItems[row.id])
    .map((row) => ({
      chechedValue: true,
      uniqueValue: row.id,
      suggested_cost: Number(
        inputValues[`cost_${row.id}`] ||
        row.integrated_video_cost
      ),
    }));

  if (selectedRows.length === 0) {
    toast.error("Please select at least one influencer.");
    return;
  }

  const payload = {
    sub_req_id: String(selectedData?.id),
    selectedRows,
  };

  console.log("Payload =>", payload);

  dispatch(manualInfluencerSuggested(payload))
    .unwrap()
    .then((result) => {
      if (result.status) {
        toast.success(result.message);
      }
    })
    .catch((err) => {
      console.log(err);
      toast.error("Something went wrong");
    });
}
  };

  const isAllCheckboxDisabled = updatedRequestData.every(
    (data) => data?.SuggestionStatus !== 0,
  );

  const formatCost = (cost) => {
    if (cost >= 1e6) {
      return (cost / 1e6).toFixed(1) + "M"; // For values above 1 million
    } else if (cost >= 1e3) {
      return (cost / 1e3).toFixed(1) + "k"; // For values above 1 thousand
    } else {
      return cost; // For values less than 1 thousand
    }
  };
  const handleBtnSubmit = (dataRows, index) => {
   const cost = inputValues[`cost_${dataRows.id}`];

    setInputErrors((prev) => ({ ...prev, [index]: false }));
    if (!cost) {
      setInputErrors((prev) => ({ ...prev, [index]: true }));
      toast.error(
        `Please enter cost for ${dataRows?.influencer_info?.name || "the influencer"}.`,
      );
      return null; // Skip this row
    }

    const influencerCost = dataRows?.influencer_channel_video_cost; // Assuming this holds the influencer's cost
    if (parseFloat(cost) <= parseFloat(influencerCost)) {
      setInputErrors((prev) => ({ ...prev, [index]: true }));
      toast.error(
        `The cost for ${dataRows?.influencer_info?.name} must be less than the influencer's cost (${influencerCost}).`,
      );
      return null; // Skip this row
    }
    const selectedRows = [
      {
        chechedValue: checkedItems[dataRows.id] || false,
        uniqueValue: dataRows?.uniqueValue,
        dm_cost: cost, // Editable cost
      },
    ];

    if (selectedRows.length === 0) {
      const requestDataToSend = { selectedRows };
      dispatch(clientInfluencerSuggested(requestDataToSend))
        .unwrap()
        .then((result) => {
          if (result.status) {
            setToastDisplayed(true);
            toast.success(result.message, {
              onClose: () => {
                setToastDisplayed(false);
                // Update the requestData and updatedRequestData on toast close
                setUpdatedRequestData((prevData) =>
                  prevData.map((item, index) =>
                    checkedItems[index]
                      ? { ...item, dm_cost: inputValues[`cost${index}`] }
                      : item,
                  ),
                );
                setRequestData(influencerRequestDatadetails?.data || []);
                setCheckedItems([]);
                setIsAllChecked([]);
              },
            });
          }
        });
    }
  };

  const handleBtnManualSubmit = (dataRows, index) => {
  const cost = inputValues[`cost_${dataRows.id}`];

    setInputErrors((prev) => ({ ...prev, [dataRows?.id]: false }));
    if (!cost) {
      setInputErrors((prev) => ({ ...prev, [dataRows?.id]: true }));
      toast.error(
        `Please enter cost for ${dataRows?.influencer_info?.name || "the influencer"}.`,
      );
      return null; // Skip this row
    }

    const influencerCost = dataRows?.influencer_channel_video_cost; // Assuming this holds the influencer's cost
    if (parseFloat(cost) <= parseFloat(influencerCost)) {
      setInputErrors((prev) => ({ ...prev, [dataRows?.id]: true }));
      toast.error(
        `The cost for ${dataRows?.influencer_info?.name} must be less than the influencer's cost (${influencerCost}).`,
      );
      return null; // Skip this row
    }
    console.log("data ==?", dataRows);

    const selectedRows = [
      {
        chechedValue: checkedItems[dataRows.id] || false,
    suggested_cost: Number(cost),
    uniqueValue: dataRows.id,
      },
    ];

    const requestDataToSend = {
      sub_req_id: String(selectedData?.id),
      selectedRows,
    };

    console.log("requestDataToSend requestDataToSend ==>", requestDataToSend);
    
  dispatch(manualInfluencerSuggested(requestDataToSend))
    .unwrap()
    .then((result) => {
      if (result.status) {

        setUpdatedRequestData((prev) =>
          prev.map((item) =>
            item.id === dataRows.id
              ? {
                  ...item,
                  suggested_cost: cost,
                }
              : item
          )
        );

        setInputValues((prev) => {
          const updated = { ...prev };
          delete updated[`cost_${dataRows.id}`];
          return updated;
        });

        toast.success(result.message);
      }
    });
};

  // const handleBtnManualSubmit = (dataRows, index) => {
  //   const cost = inputValues[`cost_${dataRows.id}`];

  //   setInputErrors((prev) => ({ ...prev, [index]: false }));
  //   if (!cost) {
  //     setInputErrors((prev) => ({ ...prev, [index]: true }));
  //     toast.error(
  //       `Please enter cost for ${dataRows?.influencer_info?.name || "the influencer"}.`,
  //     );
  //     return null; // Skip this row
  //   }

  //   const influencerCost = dataRows?.influencer_channel_video_cost; // Assuming this holds the influencer's cost
  //   if (parseFloat(cost) < parseFloat(influencerCost)) {
  //     setInputErrors((prev) => ({ ...prev, [index]: true }));
  //     toast.error(
  //       `The cost for ${dataRows?.influencer_info?.name} must be less than the influencer's cost (${influencerCost}).`,
  //     );
  //     return null; // Skip this row
  //   }
  //   console.log("data ==?", dataRows);

  //   const selectedRows = [
  //     {
  //       chechedValue: checkedItems[`${index}`] || false,
  //       suggested_cost: cost,
  //       uniqueValue: dataRows?.id,
  //     },
  //   ];

  //   const requestDataToSend = {
  //     sub_req_id: String(selectedData?.id),
  //     selectedRows,
  //   };

  //   console.log("kzkjffjdskfjdskfj ==>", requestDataToSend);

  //   if (selectedRows !== "") {
  //     // const requestDataToSend = { selectedRows };
  //     dispatch(manualInfluencerSuggested(requestDataToSend))
  //       .unwrap()
  //       .then((result) => {
  //         if (result.status) {
  //           setToastDisplayed(true);
  //           toast.success(result.message, {
  //             onClose: () => {
  //               setToastDisplayed(false);
  //               // Update the requestData and updatedRequestData on toast close
  //               setUpdatedRequestData((prevData) =>
  //                 prevData.map((item, index) =>
  //                   checkedItems[index]
  //                     ? { ...item, dm_cost: inputValues[`cost${index}`] }
  //                     : item,
  //                 ),
  //               );
  //               setRequestData(influencerRequestDatadetails?.data || []);
  //               setCheckedItems([]);
  //               setIsAllChecked([]);
  //             },
  //           });
  //         }
  //       });
  //   }
  // };

  const handleViewDetails = (data) => {
    navigate(`/suggested-influencer-details_by_unique/${data?.id}`, {
      state: data,
    });
  };

  const uniqueInfluencers = new Set(
    updatedRequestData.map((item) => item?.uniqueValue).filter(Boolean),
  );

  const uniqueCount = uniqueInfluencers.size;
  const handleBack = () => {
    navigate(-1);
  };

  const autoSuggestedData = updatedRequestData.filter(
    (item) => item?.suggested_type === "auto",
  );

  const manualInfluencers = updatedRequestData.filter(
    (item) => Number(item?.infStatus) === 0,
  );
  console.log("manualInfluencers manualInfluencers ==>", manualInfluencers);

  const suggestedInfluencers = updatedRequestData.filter(
    (item) => Number(item?.infStatus) === 1,
  );
  console.log(
    "suggestedInfluencers suggestedInfluencers ==>",
    suggestedInfluencers,
    "updatedRequestData ==>",
    updatedRequestData,
  );

  useEffect(() => {
    if (!isInitialLoadDone) return;

    let payload = {
      inf_req_id: selectedData?.id,
      status_id: formData?.infnr_status?.value || "99",
      page: currentPage,
      limit: clientsPerPage === 2000 ? "All" : clientsPerPage,
      inf_type: null,
      user_id: null,
      follower_subscriber: null,
      filter_channel: null,
      language_filter: null,
    };

    // Apply filters if selected
    if (isFilterApplied && appliedFilters) {
      payload = {
        ...appliedFilters,
        page: currentPage,
        limit: clientsPerPage === 2000 ? "All" : clientsPerPage,
      };
    }

    dispatch(clientInfluencerDataRequestDetails({ payload, activeTab }));
  }, [
    dispatch,
    currentPage,
    clientsPerPage,
    appliedFilters,
    isFilterApplied,
    isInitialLoadDone,
  ]);

  const getInfluencerList = (customPayload = {}) => {
    const payload = {
      inf_req_id: selectedData?.id,
      status_id: formData?.infnr_status?.value || "99",
      page: currentPage,
      limit: clientsPerPage === 2000 ? "All" : clientsPerPage,
      inf_type: null,
      user_id: null,
      follower_subscriber: null,
      filter_channel: null,
      language_filter: null,
      ...customPayload,
    };

    dispatch(clientInfluencerDataRequestDetails({ payload, activeTab }));
  };

  const updateFilterCount = () => {
    const saved = localStorage.getItem("manual_influencer_filters");

    if (!saved) {
      setFilterCount(0);
      return;
    }

    try {
      const parsed = JSON.parse(saved);

      let count = 0;

      // ✅ Generic function to count only valid selected filters
      const countFilter = (filter) => {
        if (!filter) return 0;

        // Multi Select
        if (Array.isArray(filter)) {
          return filter.filter(
            (item) =>
              item &&
              item.value !== null &&
              item.value !== "" &&
              item.value !== undefined,
          ).length;
        }

        // Single Select
        return filter.value !== null &&
          filter.value !== "" &&
          filter.value !== undefined
          ? 1
          : 0;
      };

      // ✅ Count all filters
      count += countFilter(parsed?.inf_type);
      count += countFilter(parsed?.user_id);
      count += countFilter(parsed?.follower_subscriber);
      count += countFilter(parsed?.filter_channel);
      count += countFilter(parsed?.language_filter);
      count += countFilter(parsed?.status_id);
      setFilterCount(count);
    } catch (err) {
      console.error(err);
      setFilterCount(0);
    }
  };
  useEffect(() => {
    const savedFilters = localStorage.getItem("manual_influencer_filters");

    try {
      if (savedFilters) {
        const parsed = JSON.parse(savedFilters);

        setFormData((prev) => ({
          ...prev,
          inf_req_id: selectedData?.id,
          inf_type: parsed?.inf_type || null,
          userName: parsed?.user_id || null,
          follower_subscriber: parsed?.follower_subscriber || null,
          filter_channel: parsed?.filter_channel || null,
          language_filter: parsed?.language_filter || null,
          infnr_status: parsed?.status_id || { value: "99", label: "All" },
        }));

        const payload = {
          inf_req_id: selectedData?.id,
          status_id: parsed?.status_id?.value || "99",
          page: 1,
          limit: clientsPerPage === 2000 ? "All" : clientsPerPage,

          inf_type: Array.isArray(parsed?.inf_type)
            ? parsed.inf_type.map((i) => i.value)
            : parsed?.inf_type?.value || null,

          user_id: Array.isArray(parsed?.user_id)
            ? parsed.user_id.map((i) => i.value)
            : parsed?.user_id?.value || null,

          follower_subscriber: parsed?.follower_subscriber?.value || null,

          filter_channel: parsed?.filter_channel?.value || null,

          language_filter: parsed?.language_filter?.value || null,
        };

        setAppliedFilters(payload);

        // ✅ API CALL ONLY ONE TIME
        getInfluencerList(payload);

        updateFilterCount();
      } else {
        // ✅ DEFAULT API CALL ONLY ONE TIME
        getInfluencerList({
          status_id: "99",
          page: 1,
        });
      }
      setIsInitialLoadDone(true);
    } catch (error) {
      console.error("Invalid localStorage filter data", error);

      getInfluencerList({
        status_id: "99",
        page: 1,
      });
      setIsInitialLoadDone(true);
    }
  }, []);

  const handleFilter = () => {
    let infTypeValue = null;

    if (Array.isArray(formData?.inf_type)) {
      infTypeValue = formData.inf_type.map((i) => Number(i.value));
    } else if (formData?.inf_type?.value) {
      infTypeValue = Number(formData.inf_type.value);
    }

    // ✅ user_id value
    let userIdValue = null;

    if (formData?.userName?.value) {
      userIdValue = Number(formData.userName.value);
    }
    let filtersChannel = null;
    if (formData?.filter_channel?.value) {
      filtersChannel = formData?.filter_channel?.value;
    }
    const followSubscriberId = formData?.follower_subscriber?.value || "";
    let filtersLanguage = null;
    if (formData?.language_filter?.value) {
      filtersLanguage = formData?.language_filter?.value;
    }
    let filtersInfnrStatus = String(formData?.infnr_status?.value) || "99";
    const payload = {
      inf_req_id: selectedData?.id,
      status_id: filtersInfnrStatus || "99",
      page: 1,
      limit: clientsPerPage === 2000 ? "All" : clientsPerPage,
      inf_type: infTypeValue || null,
      user_id: userIdValue || null,
      follower_subscriber: followSubscriberId,
      filter_channel: filtersChannel,
      language_filter: filtersLanguage,
    };

    const filterUIData = {
      inf_req_id: selectedData?.id,
      inf_type: formData?.inf_type || null,
      user_id: formData?.userName || null,
      follower_subscriber: formData?.follower_subscriber,
      filterType, // optional (good for restoring tab)
      filter_channel: formData?.filter_channel,
      language_filter: formData?.language_filter,
      status_id: formData?.infnr_status,
    };

    setAppliedFilters(payload);
    setIsFilterApplied(true);
    setCurrentPage(1);
    getInfluencerList(payload);
    setShowFiltersDrawer(false);

    localStorage.setItem(
      "manual_influencer_filters",
      JSON.stringify(filterUIData),
    );

    updateFilterCount();
  };

  const handleReset = () => {
    setFormData({
      inf_type: DEFAULT_INF_TYPE,
      userName: null,
      follower_subscriber: null,
      filter_channel: null,
      language_filter: null,
      infnr_status: { value: "99", label: "All" },
    });
    localStorage.removeItem("manual_influencer_filters");

    setAppliedFilters(null);
    setIsFilterApplied(false);
    setCurrentPage(1);
    setShowFiltersDrawer(false);

    setFilterCount(0); // ✅ MUST
  };

  const reqId = influencerRequestDatadetails?.request_details?.req_code;

  const pagination = influencerRequestDatadetails?.pagination || {};

  const totalRecords = pagination.totalItems || 0;
  const totalPages = pagination.totalPages || 0;
  const currentPageNo = pagination.page || currentPage;
  const pageLimit = pagination.limit || clientsPerPage;

  const startRecord =
    totalRecords > 0 ? (currentPageNo - 1) * pageLimit + 1 : 0;

  const endRecord = Math.min(currentPageNo * pageLimit, totalRecords);

  // const totalPages = Math.ceil(
  //   totalRecords / clientsPerPage
  // );

  const getPaginationPages = () => {
    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1, 2, 3);

      if (currentPage > 5) {
        pages.push("...");
      }

      const start = Math.max(4, currentPage - 1);
      const end = Math.min(totalPages - 3, currentPage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (currentPage < totalPages - 4) {
        pages.push("...");
      }

      pages.push(totalPages - 2, totalPages - 1, totalPages);
    }

    return [...new Set(pages)];
  };

  return (
    <>
      <ToastContainer />
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Suggested Influencer</h4>
            <div className="page-title-right">
              <Breadcrumbs />
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="leadsList">
              <div className="card-header border-0">
                <div className="row g-4 align-items-center">
                  <div className="col-sm-auto ms-auto">
                    <div className="hstack gap-2">
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={handleBack}
                      >
                        ← Back
                      </Button>
                      <button
                        type="button"
                        className="btn btn-sm btn-success add-btn"
                        onClick={handleSubmitBtn}
                      >
                        <i className="ri-add-line align-bottom me-1"></i> Send
                        Selected Influencers
                      </button>
                      {/* <button
                        type="button"
                        className="btn btn-sm btn-info"
                        // data-bs-toggle="offcanvas"
                        // href="#offcanvasExample"
                      >
                        <i className="ri-filter-3-line align-bottom me-1"></i>{" "}
                        Filters
                      </button> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body border-top">
                <p>
                  Client With The Request Id:{" "}
                  <strong>
                    {influencerRequestDatadetails?.request_details?.req_code}
                  </strong>{" "}
                  have requirement of Total Influencer:{" "}
                  <strong>
                    {
                      influencerRequestDatadetails?.request_details
                        ?.no_of_influencer
                    }
                  </strong>
                  , Other details are mentioned below:
                </p>
                {Object.keys(channelData).length > 0 && (
                  <table className="table table-bordered table-striped rounded">
                    <thead>
                      <tr>
                        {Object.keys(headerData).map((key) => (
                          <th key={key}>{headerData[key]}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(channelData).map(([channel, data]) => (
                        <tr key={channel}>
                          <td>{channel}</td>
                          <td>
                            {data?.follower_subscriber
                              ?.map((followSub) => followSub.label)
                              .join(", ") || "-"}
                          </td>
                          <td>
                            {data?.language
                              ?.map((lang) => lang.label)
                              .join(", ") || "-"}
                          </td>
                          <td>
                            {data?.video_type
                              ?.map((videoType) => videoType.label)
                              .join(", ") || "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
              <div className="card-body">
                <ul className="nav nav-tabs mb-3">
                  <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeTab === "auto" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("auto")}
                    >
                      Auto Suggest
                    </button>
                  </li>

                  <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeTab === "manual" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("manual")}
                    >
                      Manual Suggest
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link ${activeTab === "suggested" ? "active" : ""}`}
                      onClick={() => setActiveTab("suggested")}
                    >
                      Suggested Influencers
                    </button>
                  </li>
                </ul>

                {/* AUTO SUGGESTED CONTENT */}
                {activeTab === "auto" && (
                  <div className="table-responsive">
                    <div className="col-sm-12 border rounded px-2 py-3 background-secodary  mb-2 bg-light text-dark">
                      <h5>Auto Suggested Influencers</h5>
                      <p>
                        <strong>Hello, 😎 {decodedToken?.UsrName}</strong> you
                        have only{" "}
                        <strong>{uniqueCount} Active Influencers</strong>, which
                        is listed below.
                      </p>
                      <hr />
                      <p>
                        <strong>Note:</strong> Please select the required
                        checkboxes below and then click on "Send Selected
                        Influencers" on the top right of your screen to submit a
                        request for an Influencer Request ID{" "}
                        {
                          influencerRequestDatadetails?.request_details
                            ?.req_code
                        }
                        .
                      </p>
                    </div>

                    <div className="table-responsive">
                      {updatedRequestData.length > 0 && !toastDisplayed && (
                        <table className="table table-bordered table-striped rounded">
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  checked={isAllChecked}
                                  onChange={(e) =>
                                    handleHeaderCheckboxChange(e.target.checked)
                                  }
                                  disabled={isAllCheckboxDisabled} // Disable if all rows are not selectable
                                />
                              </th>
                              {Object.keys(headerDataInfluencer).map((key) => (
                                <th key={key}>{headerDataInfluencer[key]}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {updatedRequestData.map((data, index) => (
                              <tr key={data.id}>
                                <td>
                                  <input
                                    type="checkbox"
                                    name={`${index}`}
                                    disabled={
                                      data?.SuggestionStatus !== 0
                                        ? true
                                        : false
                                    }
                                    checked={checkedItems[`${index}`] || false}
                                    onChange={handleCheckboxChange}
                                  />
                                </td>
                                <td>
                                  {
                                    influencerRequestDatadetails
                                      ?.request_details?.req_code
                                  }
                                </td>
                                <td>{data?.influencer_info?.name}</td>
                                <td>{data?.influencer_channel_name}</td>
                                <td>
                                  {data?.influencer_channel_video_type || "-"}
                                </td>
                                <td>
                                  {formatCost(
                                    data?.influencer_channel_video_cost,
                                  )}
                                </td>
                                <td>
                                  <ul className="list-inline hstack gap-0 mb-0">
                                    <li className="list-inline-item m-0">
                                      <FormattedInput
                                        type="number"
                                        className={`form-control ${inputErrors[index] ? "is-invalid" : ""}`} // Apply width class
                                        disabled={
                                          data?.SuggestionStatus !== 0
                                            ? true
                                            : false
                                        }
                                        name={`cost${index}`}
                                        placeholder="Enter cost"
                                        value={
                                          inputValues[`cost${index}`] ||
                                          data?.dm_cost
                                        }
                                        onChange={handleInputChange}
                                      />
                                    </li>
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      data-bs-trigger="hover"
                                      data-bs-placement="top"
                                      aria-label="Submit"
                                      data-bs-original-title="Submit"
                                    >
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="tooltip-top">
                                            Submit
                                          </Tooltip>
                                        }
                                      >
                                        <button
                                          className="btn btn-sm btn-success"
                                          onClick={() =>
                                            handleBtnSubmit(data, index)
                                          }
                                          disabled={
                                            data?.SuggestionStatus !== 0
                                          }
                                        >
                                          <i className="ri-checkbox-circle-fill align-bottom fs-16"></i>
                                        </button>
                                      </OverlayTrigger>
                                    </li>
                                  </ul>
                                </td>
                                <td>{data?.label || "-"}</td>
                                <td>{data?.influencer_channel_url || "-"}</td>
                                <td>
                                  {formatCost(
                                    data?.influencer_channel_subscribers,
                                  ) || "-"}
                                </td>
                                <td>
                                  {formatCost(
                                    data?.influencer_channel_average_Views,
                                  ) || "-"}
                                </td>
                                <td>
                                  {data?.influencer_channel_language || ""}
                                </td>
                                <td>
                                  <ul className="list-inline hstack mb-0">
                                    <li className="list-inline-item">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="tooltip-top">
                                            Add Video
                                          </Tooltip>
                                        }
                                      >
                                        <Button
                                          title="Request send to DM"
                                          className="btn btn-sm btn-info edit-item-btn"
                                          onClick={() => handleAddVideo(data)}
                                        >
                                          <i className="ri-add-fill align-bottom me-1"></i>
                                        </Button>
                                      </OverlayTrigger>
                                    </li>
                                    {/* <li className="list-inline-item">
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                    <Tooltip id="tooltip-top">
                                                                        View Details
                                                                    </Tooltip>
                                                                    }
                                                                >
                                                                    <Button
                                                                    title="Request send to DM"
                                                                    className="btn btn-sm btn-info edit-item-btn"
                                                                    onClick={() => handleViewDetails(data)}
                                                                    >
                                                                    <i className="ri-eye-fill align-bottom me-1"></i>
                                                                    </Button>
                                                                </OverlayTrigger>
                                                                </li> */}
                                  </ul>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                )}

                {/* CUSTOM SUGGESTED CONTENT */}
                {activeTab === "manual" && (
                  <div className="table-responsive">
                    <div className="col-sm-12 border rounded px-2 py-3 background-secodary  mb-2 bg-light text-dark">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0">Manual Suggested Influencers</h5>
                        <div className="justify-content-end">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="inactive-filter-tooltip">
                                Add Filter
                              </Tooltip>
                            }
                          >
                            <div className="position-relative d-inline-block me-2">
                              <button
                                type="button"
                                className="btn btn-info"
                                onClick={() => openFilterDrawer("all")}
                              >
                                <i className="ri-filter-line"></i>
                              </button>

                              {filterCount > 0 && (
                                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                  {filterCount}
                                </span>
                              )}
                            </div>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="inactive-clear-filter-tooltip">
                                Clear Filter
                              </Tooltip>
                            }
                          >
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={handleReset}
                            >
                              <i className="ri-filter-off-line align-bottom me-1"></i>{" "}
                            </button>
                          </OverlayTrigger>
                        </div>
                      </div>

                      <hr />
                      <p>
                        <strong>Note:</strong> Please select the required
                        checkboxes below and then click on "Send Selected
                        Influencers" on the top right of your screen to submit a
                        request for an Influencer Request ID{" "}
                        {
                          influencerRequestDatadetails?.request_details
                            ?.req_code
                        }
                        .
                      </p>
                    </div>

                    <div className="table-responsive">
                      {updatedRequestData.length > 0 && !toastDisplayed && (
                        <>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              Show
                              <select
                                className="form-select d-inline-block mx-2"
                                style={{ width: "100px" }}
                                value={clientsPerPage}
                                onChange={(e) => {
                                  setClientsPerPage(Number(e.target.value));
                                  setCurrentPage(1);
                                }}
                              >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                                <option value={2000}>All</option>
                              </select>
                              Entries
                            </div>
                          </div>
                          <table className="table table-bordered table-striped rounded">
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    type="checkbox"
                                    checked={isAllChecked}
                                    onChange={(e) =>
                                      handleHeaderCheckboxChange(
                                        e.target.checked,
                                      )
                                    }
                                  />
                                </th>
                                {Object.keys(headerManulDataInfluencer).map(
                                  (key) => (
                                    <th key={key}>
                                      {headerManulDataInfluencer[key]}
                                    </th>
                                  ),
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {manualInfluencers?.map((data, index) => {
                                return (
                                  activeTab === "manual" && (
                                    <tr key={data.id}>
                                      <td>
                                        {/* <input
                                          type="checkbox"
                                          name={`${index}`}
                                          // disabled={
                                          //   data?.status !== 0
                                          //     ? true
                                          //     : false
                                          // }
                                          checked={
                                            checkedItems[`${data?.id}`] || false
                                          }
                                          onChange={handleCheckboxChange}
                                        /> */}

                                        <input
  type="checkbox"
  name={`${data.id}`}
  checked={checkedItems[data.id] || false}
  onChange={handleCheckboxChange}
/>
                                      </td>
                                      {/* <td>{selectedData?.id}</td> */}
                                      <td>{data?.name}</td>
                                      <td>{data?.channel_name}</td>
                                      <td>
                                        {data?.influencer_channel_video_type ||
                                          "-"}
                                      </td>
                                      <td>
                                        {formatCost(
                                          data?.integrated_video_cost || "-",
                                        )}
                                      </td>
                                      <td>
                                        <ul className="list-inline hstack gap-0 mb-0">
                                          <li className="list-inline-item m-0">
                                            {/* <FormattedInput
                                              type="number"
                                              className={`form-control ${inputErrors[index] ? "is-invalid" : ""}`} // Apply width class
                                              disabled={
                                                data?.SuggestionStatus !== 0
                                                  ? true
                                                  : false
                                              }
                                              name={`cost${index}`}
                                              placeholder="Enter cost"
                                              value={
                                                inputValues[`cost${index}`] ||
                                                data?.dm_cost
                                              }
                                              onChange={handleInputChange}
                                            /> */}
                                            <FormattedInput
  type="number"
  className={`form-control ${
    inputErrors[data?.id] ? "is-invalid" : ""
  }`}
  name={`cost_${data?.id}`}
  placeholder="Enter cost"
  value={inputValues[`cost_${data.id}`] ?? ""}
  onChange={handleInputChange}
/>
                                          </li>
                                          <li
                                            className="list-inline-item"
                                            data-bs-toggle="tooltip"
                                            data-bs-trigger="hover"
                                            data-bs-placement="top"
                                            aria-label="Submit"
                                            data-bs-original-title="Submit"
                                          >
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={
                                                <Tooltip id="tooltip-top">
                                                  Submit
                                                </Tooltip>
                                              }
                                            >
                                              <button
                                                className="btn btn-sm btn-success"
                                                onClick={() =>
                                                  handleBtnManualSubmit(
                                                    data,
                                                    index,
                                                  )
                                                }
                                                // disabled={
                                                //   data?.SuggestionStatus !== 0
                                                // }
                                              >
                                                <i className="ri-checkbox-circle-fill align-bottom fs-16"></i>
                                              </button>
                                            </OverlayTrigger>
                                          </li>
                                        </ul>
                                      </td>
                                      <td>{data?.video_category || "-"}</td>
                                      <td>
                                        <Link
                                          to={
                                            data?.channel_data?.instagram
                                              ?.instagram_URL || "#"
                                          }
                                          className="btn btn-primary btn-sm"
                                        >
                                          Click here
                                        </Link>
                                      </td>
                                      <td>
                                        {formatCost(
                                          data?.channel_data?.instagram
                                            ?.followers,
                                        ) || "-"}
                                      </td>
                                      <td>
                                        {formatCost(
                                          data?.influencer_channel_average_Views,
                                        ) || "-"}
                                      </td>
                                      <td>{getLanguages(data?.language)}</td>

                                      <td>
                                        <ul className="list-inline hstack mb-0">
                                          <li className="list-inline-item">
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={
                                                <Tooltip id="tooltip-top">
                                                  Add Video
                                                </Tooltip>
                                              }
                                            >
                                              <Button
                                                title="Request send to DM"
                                                className="btn btn-sm btn-info edit-item-btn"
                                                onClick={() =>
                                                  handleAddVideo(data)
                                                }
                                              >
                                                <i className="ri-add-fill align-bottom me-1"></i>
                                              </Button>
                                            </OverlayTrigger>
                                          </li>
                                        </ul>
                                      </td>
                                    </tr>
                                  )
                                );
                              })}
                            </tbody>
                          </table>
                          <div className="row mt-3">
                            <div className="col-12">
                              <div className="d-flex justify-content-between align-items-center">
                                <div className="text-muted">
                                  Showing {startRecord} to {endRecord} of{" "}
                                  {totalRecords} records
                                </div>

                                <nav>
                                  <ul className="pagination mb-0">
                                    <li
                                      className={`page-item ${
                                        currentPage === 1 ? "disabled" : ""
                                      }`}
                                    >
                                      <button
                                        className="page-link"
                                        onClick={() =>
                                          setCurrentPage(currentPage - 1)
                                        }
                                      >
                                        Previous
                                      </button>
                                    </li>

                                    {getPaginationPages().map((page, index) =>
                                      page === "..." ? (
                                        <li
                                          key={index}
                                          className="page-item disabled"
                                        >
                                          <span className="page-link">...</span>
                                        </li>
                                      ) : (
                                        <li
                                          key={index}
                                          className={`page-item ${
                                            currentPage === page ? "active" : ""
                                          }`}
                                        >
                                          <button
                                            className="page-link"
                                            onClick={() => setCurrentPage(page)}
                                          >
                                            {page}
                                          </button>
                                        </li>
                                      ),
                                    )}

                                    <li
                                      className={`page-item ${
                                        currentPage === totalPages
                                          ? "disabled"
                                          : ""
                                      }`}
                                    >
                                      <button
                                        className="page-link"
                                        onClick={() =>
                                          setCurrentPage(currentPage + 1)
                                        }
                                      >
                                        Next
                                      </button>
                                    </li>
                                  </ul>
                                </nav>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}

                {activeTab === "suggested" && (
                  <div className="table-responsive">
                    <div className="col-sm-12 border rounded px-2 py-3 background-secodary  mb-2 bg-light text-dark">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0">Suggested Influencers</h5>
                        <div className="justify-content-end">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="inactive-filter-tooltip">
                                Add Filter
                              </Tooltip>
                            }
                          >
                            <div className="position-relative d-inline-block me-2">
                              <button
                                type="button"
                                className="btn btn-info"
                                onClick={() => openFilterDrawer("all")}
                              >
                                <i className="ri-filter-line"></i>
                              </button>

                              {filterCount > 0 && (
                                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                  {filterCount}
                                </span>
                              )}
                            </div>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="inactive-clear-filter-tooltip">
                                Clear Filter
                              </Tooltip>
                            }
                          >
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={handleReset}
                            >
                              <i className="ri-filter-off-line align-bottom me-1"></i>{" "}
                            </button>
                          </OverlayTrigger>
                        </div>
                      </div>

                      <hr />
                      <p>
                        <strong>Note:</strong> Please select the required
                        checkboxes below and then click on "Send Selected
                        Influencers" on the top right of your screen to submit a
                        request for an Influencer Request ID{" "}
                        {
                          influencerRequestDatadetails?.request_details
                            ?.req_code
                        }
                        .
                      </p>
                    </div>

                    <div className="table-responsive">
                      {suggestedInfluencers.length > 0 && !toastDisplayed && (
                        <>
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              Show
                              <select
                                className="form-select d-inline-block mx-2"
                                style={{ width: "100px" }}
                                value={clientsPerPage}
                                onChange={(e) => {
                                  setClientsPerPage(Number(e.target.value));
                                  setCurrentPage(1);
                                }}
                              >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                                <option value={2000}>All</option>
                              </select>
                              Entries
                            </div>
                          </div>
                          <table className="table table-bordered table-striped rounded">
                            <thead>
                              <tr>
                                <th>
                                  <input
                                    type="checkbox"
                                    checked={isAllChecked}
                                    onChange={(e) =>
                                      handleHeaderCheckboxChange(
                                        e.target.checked,
                                      )
                                    }
                                    disabled={isAllCheckboxDisabled} // Disable if all rows are not selectable
                                  />
                                </th>
                                {Object.keys(headerManulDataInfluencer).map(
                                  (key) => (
                                    <th key={key}>
                                      {headerManulDataInfluencer[key]}
                                    </th>
                                  ),
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {suggestedInfluencers?.map((data, index) => {
                                console.log(
                                  "data?.infStatus === 1 ==>",
                                  typeof data.infStatus,
                                  data.infStatus,
                                );

                                return (
                                  activeTab === "suggested" && (
                                    <tr key={index}>
                                      <td>
                                        <input
                                          type="checkbox"
                                          name={`${index}`}
                                          disabled={
                                            data?.infStatus !== 0 ? true : false
                                          }
                                          checked={
                                            checkedItems[`${index}`] || false
                                          }
                                          onChange={handleCheckboxChange}
                                        />
                                      </td>
                                      {/* <td>{selectedData?.id}</td> */}
                                      <td>{data?.name}</td>
                                      <td>{data?.channel_name}</td>
                                      <td>
                                        {data?.influencer_channel_video_type ||
                                          "-"}
                                      </td>
                                      <td>
                                        {formatCost(
                                          data?.integrated_video_cost || "-",
                                        )}
                                      </td>
                                      <td>
                                        <ul className="list-inline hstack gap-0 mb-0">
                                          <li className="list-inline-item m-0">
                                            <input
                                              type="number"
                                              className={`form-control ${inputErrors[index] ? "is-invalid" : ""}`} // Apply width class
                                              readOnly={
                                                Number(data?.infStatus) === 1
                                              }
                                              name={`cost${index}`}
                                              placeholder="Enter cost"
                                              value={
                                                data?.suggested_cost
                                              }
                                              onChange={handleInputChange}
                                            />
                                          </li>
                                          <li
                                            className="list-inline-item"
                                            data-bs-toggle="tooltip"
                                            data-bs-trigger="hover"
                                            data-bs-placement="top"
                                            aria-label="Submit"
                                            data-bs-original-title="Submit"
                                          >
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={
                                                <Tooltip id="tooltip-top">
                                                  Submit
                                                </Tooltip>
                                              }
                                            >
                                              <button
                                                className="btn btn-sm btn-success"
                                                onClick={() =>
                                                  handleBtnSubmit(data, index)
                                                }
                                                disabled={data?.infStatus === 1}
                                              >
                                                <i className="ri-checkbox-circle-fill align-bottom fs-16"></i>
                                              </button>
                                            </OverlayTrigger>
                                          </li>
                                        </ul>
                                      </td>
                                      <td>{data?.video_category || "-"}</td>
                                      <td>
                                        <Link
                                          to={
                                            data?.channel_data?.instagram
                                              ?.instagram_URL || "#"
                                          }
                                          className="btn btn-primary btn-sm"
                                        >
                                          Click here
                                        </Link>
                                      </td>
                                      <td>
                                        {formatCost(
                                          data?.channel_data?.instagram
                                            ?.followers,
                                        ) || "-"}
                                      </td>
                                      <td>
                                        {formatCost(
                                          data?.influencer_channel_average_Views,
                                        ) || "-"}
                                      </td>
                                      <td>{getLanguages(data?.language)}</td>

                                      <td>
                                        <ul className="list-inline hstack mb-0">
                                          <li className="list-inline-item">
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={
                                                <Tooltip id="tooltip-top">
                                                  Add Video
                                                </Tooltip>
                                              }
                                            >
                                              <Button
                                                title="Request send to DM"
                                                className="btn btn-sm btn-info edit-item-btn"
                                                onClick={() =>
                                                  handleAddVideo(data)
                                                }
                                              >
                                                <i className="ri-add-fill align-bottom me-1"></i>
                                              </Button>
                                            </OverlayTrigger>
                                          </li>
                                        </ul>
                                      </td>
                                    </tr>
                                  )
                                );
                              })}
                            </tbody>
                          </table>
                          <div className="row mt-3">
                            <div className="col-12">
                              <div className="d-flex justify-content-between align-items-center">
                                <div className="text-muted">
                                  Showing {startRecord} to {endRecord} of{" "}
                                  {totalRecords} records
                                </div>

                                <nav>
                                  <ul className="pagination mb-0">
                                    <li
                                      className={`page-item ${
                                        currentPage === 1 ? "disabled" : ""
                                      }`}
                                    >
                                      <button
                                        className="page-link"
                                        onClick={() =>
                                          setCurrentPage(currentPage - 1)
                                        }
                                      >
                                        Previous
                                      </button>
                                    </li>

                                    {getPaginationPages().map((page, index) =>
                                      page === "..." ? (
                                        <li
                                          key={index}
                                          className="page-item disabled"
                                        >
                                          <span className="page-link">...</span>
                                        </li>
                                      ) : (
                                        <li
                                          key={index}
                                          className={`page-item ${
                                            currentPage === page ? "active" : ""
                                          }`}
                                        >
                                          <button
                                            className="page-link"
                                            onClick={() => setCurrentPage(page)}
                                          >
                                            {page}
                                          </button>
                                        </li>
                                      ),
                                    )}

                                    <li
                                      className={`page-item ${
                                        currentPage === totalPages
                                          ? "disabled"
                                          : ""
                                      }`}
                                    >
                                      <button
                                        className="page-link"
                                        onClick={() =>
                                          setCurrentPage(currentPage + 1)
                                        }
                                      >
                                        Next
                                      </button>
                                    </li>
                                  </ul>
                                </nav>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <CreateVideo
        showDeleteModal={addDmVideo}
        selectedRowsData={videoDmData}
        setSelectedRowsData={setVideoDmData}
        setShowDeleteModal={setAddDmVideo}
      />
      {/* <Filter
        setShowFiltersDrawer={setShowFiltersDrawer}
        showFiltersDrawer={showFiltersDrawer}
        handleFilter={handleFilter}
        formData={formData}
        setFormData={setFormData}
        activeTab={activeTab}
      /> */}
      <SubRequestFilter
        setShowFiltersDrawer={setShowFiltersDrawer}
        showFiltersDrawer={showFiltersDrawer}
        handleFilter={handleFilter}
        formData={formData}
        setFormData={setFormData}
        filterType={filterType}
        handleReset={handleReset}
        activeTab={activeTab}
      />
    </>
  );
};

export default ClientInfluencerRequestDetails;
